export const textToolFontSize = 18; // In px

export const selectionHandlersBorderWidth = 3; // In px
